module.exports = __webpack_public_path__ + "static/media/storm.62803853.png";